import React, { useState } from "react";
import {
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Collapse,
  TableContainer,
  Paper,
} from "@mui/material";
import {
  GridContainer,
  HoldingsTableContainer,
  HoldingsTable,
  HoldingsTableRow,
  HoldingsExpandButton,
  HoldingsCollapseContent,
  HoldingsTableHeader,
  DataCardTitle,
  DataCardHeader,
  GridItem,
} from "./PeriodicIso.styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import GroupsIcon from "@mui/icons-material/Groups";
import MerchantsTable from "./PeriodicIso.merchantsTable";

function RenderGroupRow(props) {
  const { row } = props;
  const [open, setOpen] = useState(false);

  const formatNumber = (value) => {
    if (typeof value === "string") {
      const num = parseFloat(value);
      return isNaN(num)
        ? value
        : num.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 4,
          });
    }
    return value?.toLocaleString("en-US") || "0";
  };

  const isPositiveAmount = (value) => {
    const num = parseFloat(value);
    return !isNaN(num) && num >= 0;
  };

  return (
    <>
      <HoldingsTableRow isOpen={open}>
        <TableCell>
          <HoldingsExpandButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </HoldingsExpandButton>
        </TableCell>
        <TableCell
          align="center"
          sx={{ fontWeight: 600, fontSize: "0.875rem" }}
        >
          ${formatNumber(row?.transactionsAmount)}
        </TableCell>
        <TableCell
          align="center"
          sx={{ fontWeight: 600, fontSize: "0.875rem" }}
        >
          {row?.transactionsCount}
        </TableCell>
        <TableCell
          align="center"
          sx={{
            fontWeight: 700,
            fontSize: "0.875rem",
            color: isPositiveAmount(row?.amountDue)
              ? "success.main"
              : "error.main",
          }}
        >
          ${formatNumber(row?.amountDue)}
        </TableCell>
        <TableCell
          align="center"
          sx={{ fontWeight: 600, fontSize: "0.875rem" }}
        >
          ${formatNumber(row?.txMDR)}
        </TableCell>
        <TableCell
          align="center"
          sx={{ fontWeight: 600, fontSize: "0.875rem" }}
        >
          ${formatNumber(row?.txProcessing)}
        </TableCell>
      </HoldingsTableRow>
      <TableRow>
        <TableCell
          style={{ paddingLeft: 30, paddingBottom: 0, paddingTop: 0 }}
          colSpan={9}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <HoldingsCollapseContent>
              <MerchantsTable merchantList={row?.merchants?.merchant} />
            </HoldingsCollapseContent>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

const GroupsTable = (props) => {
  const { groupsList } = props;

  const headers = [
    { label: "", align: "center" },
    { label: "Trans. Amount", align: "center" },
    { label: "Trans. Count", align: "center" },
    { label: "Settlement", align: "center" },
    { label: "MDR Fee", align: "center" },
    { label: "Proc. Fee", align: "center" },
  ];

  return (
    <GridContainer>
      <GridItem xs={12}>
        <DataCardHeader>
          <GroupsIcon color="primary" />
          <DataCardTitle>Brands</DataCardTitle>
        </DataCardHeader>
      </GridItem>
      <HoldingsTableContainer sx={{ width: "100%" }}>
        <TableContainer component={Paper} elevation={0} sx={{ width: "100%" }}>
          <HoldingsTable size="small" sx={{ width: "100%" }}>
            <HoldingsTableHeader>
              <TableRow>
                {headers.map((header, index) => (
                  <TableCell
                    key={index}
                    align={header.align}
                    sx={{
                      fontWeight: 700,
                      fontSize: "0.875rem",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      ...header.style,
                    }}
                  >
                    {header.label}
                  </TableCell>
                ))}
              </TableRow>
            </HoldingsTableHeader>
            <TableBody>
              {groupsList && groupsList.length > 0 ? (
                groupsList.map((group, index) => (
                  <RenderGroupRow
                    key={`group-${group.merchantHoldingID} - ${index}`}
                    row={group}
                  />
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={9} align="center" sx={{ py: 4 }}>
                    <Typography variant="body2" color="text.secondary">
                      No brands data available
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </HoldingsTable>
        </TableContainer>
      </HoldingsTableContainer>
    </GridContainer>
  );
};

export default GroupsTable;
